export const COMPANY_DETAILS = "COMPANY_DETAILS";
export const CLIENT_MANAGER_FORM_LIST = "CLIENT_MANAGER_FORM_LIST";
export const GET_COMPANY_DETAILS = "GET_COMPANY_DETAILS";
